const ProductDetailsShimmer = () => {
  return (
    <div className="animate-pulse bg-slate-50 min-h-screen">
      <div className="mx-auto w-full px-4 py-6 sm:px-6">
        <div className="grid grid-cols-1 gap-5 rounded-lg bg-white p-4 shadow-sm lg:grid-cols-[1.05fr_1fr] lg:p-6">
          {/* Left Image Section */}
          <div className="flex flex-col items-center">
            <div className="w-full md:h-[600px] h-[400px] bg-slate-200 rounded-lg mb-4"></div>

            <div className="flex gap-2 overflow-hidden">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="w-20 h-20 bg-slate-200 rounded-md" />
              ))}
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-4">
            <div className="h-4 w-32 bg-slate-200 rounded"></div>
            <div className="h-6 w-3/4 bg-slate-200 rounded"></div>

            {/* Price */}
            <div className="space-y-2">
              <div className="h-6 w-28 bg-slate-200 rounded"></div>
              <div className="h-4 w-20 bg-slate-200 rounded"></div>
            </div>

            {/* Description */}
            <div className="space-y-2">
              <div className="h-3 w-full bg-slate-200 rounded"></div>
              <div className="h-3 w-5/6 bg-slate-200 rounded"></div>
              <div className="h-3 w-4/6 bg-slate-200 rounded"></div>
            </div>

            {/* Buttons */}
            <div className="flex gap-2 mt-4">
              <div className="flex-1 h-10 bg-slate-200 rounded"></div>
              <div className="flex-1 h-10 bg-slate-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsShimmer;
